<!--<div class="modal-header">-->
<!--  <h4>{{ getTitle() }}</h4>-->
<!--  <button type="button" class="close" aria-label="Close" (click)="cancel()">-->
<!--    <span class="font-weight-light fs-20" aria-hidden="true">&times;</span>-->
<!--  </button>-->
<!--</div>-->
<div class="modal-header">
  <h4 class="modal-title pull-left">{{ getTitle() }}</h4>
  <button type="button" class="btn-close close pull-right fs-12" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true" class="visually-hidden font-weight-light">&times;</span>
  </button>
</div>
<div class="modal-body">
  <ng-container *ngIf="items.length > 0">
    <ul class="list-group-notification">
      <li *ngFor="let item of items; let i = index" class="list-group-notification-item">
        <ng-container *ngIf="item.url; else noUrlTmpl">
          <a [href]="item.url" [title]="item.name" target="_blank" class="clickable fs-14 mt-3 text-success">
            <span [ngClass]="{'text-danger': item?.status}">{{ item.name }}</span>
          </a>
        </ng-container>
        <ng-template #noUrlTmpl>
          <span [ngClass]="{'text-danger': item?.status}">{{ item.name }}</span>
        </ng-template>
         - {{ item.title }}
      </li>
    </ul>
  </ng-container>

  <!-- Extra Data WO | NO -->
  <ng-container *ngIf="item">
    <!-- Presenting Data -->
    <ng-container *ngIf="type === 'WO'">
      <app-data-work-order
        [isLoading]="isLoading"
        [data]="woData"></app-data-work-order>
    </ng-container>

    <ng-container *ngIf="type === 'NO'">
      <app-data-notification
        [isLoading]="isLoading"
        [data]="noData"></app-data-notification>
    </ng-container>
  </ng-container>

</div>
<div class="modal-footer text-center">
  <button type="button" class="btn btn-outline-danger" (click)="cancel()">
    Close
  </button>
</div>
